import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { CmsService } from '../cms/cms.service';
import { requestFailure } from '../error/error.actions';
import { getFlowRequest, getFlowResponse } from './cms.actions';

@Injectable({ providedIn: 'any' })
export class CmsEffects {
    constructor(
        private readonly actions$: Actions,
        private readonly cmsService$: CmsService,
    ) {}

    getCmsData$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(getFlowRequest),
                switchMap((action) =>
                    this.cmsService$.getQuoteFlow(action).pipe(
                        map((data) => {
                            return getFlowResponse({ data });
                        }),
                        catchError((error) => of(requestFailure(error))),
                    ),
                ),
            ),
        {
            dispatch: true,
        },
    );
}
